import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import Minicoach from "../images/minicoach.png";
import BgCard from "../images/bgCardDetailGray.png";
import { useEffect, useState } from "react";
import { ScheduleData } from "../utils/ScheduleDetail";

interface cardProps {
  isMainPage?: boolean;
  scheduleId: number;
}

const CityShuttleCard = ({ isMainPage, scheduleId }: cardProps) => {
  const [scheduleData, setScheduleData] = useState<any>([]);
  const [disabledButton, setDisabledButton] = useState<boolean>(true);

  const CheckSchedulePrice = async () => {
    var scheduleData = await ScheduleData();
    scheduleData && setScheduleData(scheduleData);
    setDisabledButton(scheduleData.bookNowButton);
    console.log(scheduleData);
  };

  useEffect(() => {
    CheckSchedulePrice();
  }, []);

  return (
    <div className="noSelect flex flex-col items-center transition-opacity my-5">
      <img
        src={BgCard}
        className={`noSelect z-0 ${
          isMainPage
            ? "h-[300px] w-[350px] md:h-[317px] md:w-[600px]"
            : "h-[230px] w-[230px] md:h-[227px] md:w-[210px] "
        }  object-fill`}
        style={{ marginTop: "40px" }}
        alt="bgCard"
      ></img>
      <div
        className={`flex absolute flex-col items-center space-y-5 md:space-y-4 justify-between`}
      >
        <img
          src={Minicoach}
          className={`noSelect h-[75px] ${isMainPage && "md:h-[105px]"} `}
          alt="carPict"
        ></img>
        <div className="flex flex-col items-center ">
          <h1
            className={`text-white font-bold text-xl ${
              isMainPage && "md:text-[27px]"
            } `}
          >
            CITY SHUTTLE
          </h1>
          {isMainPage && (
            <a className={`text-white text-lg md:text-[20px]`}>
              From Airport to{" "}
              <a
                className={`text-white text-lg md:text-[20px] font-bold underline `}
                href={`HotelList`}
                id="hotelList"
              >
                Most Downtown Hotels
              </a>
            </a>
          )}

          <div className="flex space-y-4 md:space-y-3 flex-col items-center">
            <div className="flex flex-col">
              <a
                className={`text-white text-lg text-center ${
                  isMainPage && "md:text-[20px]"
                } `}
                style={{ fontWeight: "bold" }}
              >
                {`$${(scheduleData.adultPrice / 100).toFixed(2)} Per Adult`}
              </a>
              <a
                className={`text-white text-lg text-center ${
                  isMainPage && "md:text-[20px]"
                } `}
                style={{ fontWeight: "bold" }}
              >
                {`$${(scheduleData.childPrice / 100).toFixed(2)} Per Child*`}
              </a>
            </div>

            <a
              className={`text-white text-base ${
                isMainPage && "md:text-[16px]"
              } `}
            >
              *below 12 years of age
            </a>
            {isMainPage && (
              <a className={`text-white text-center text-lg md:text-[20px] `}>
                Departs from 0700HR to 2300HR
              </a>
            )}
          </div>
        </div>
        {isMainPage && (
          <Button
            component={Link}
            disabled={disabledButton}
            id={"shuttleBooking"}
            to={`${!disabledButton && "FormBooking/CityShuttle"}`}
            onClick={() => {
              localStorage.clear();
            }}
            variant="contained"
            className={"CardButton gray"}
          >
            BOOK NOW
          </Button>
        )}
      </div>
    </div>
  );
};

export default CityShuttleCard;
